/** Agent Settings > Knowledge: which sources the agent uses and who may read each (DEC-067). */
export const agentKnowledge = {
  title: "Knowledge",
  hint: "Choose which workspace sources this agent answers from, and who may read each one.",
  summaryLabel: "Who can see what",
  guestsCan_one: "Guests can see {{count}} source",
  guestsCan_other: "Guests can see {{count}} sources",
  membersCan_one: "Signed-in users can see {{count}} source",
  membersCan_other: "Signed-in users can see {{count}} sources",
  summaryNote: "Counts the sources this agent uses that are ready, after the “Who can chat” limit.",
  capHint: "“Who can chat” limits this agent to {{levels}}. Visitors only read sources that are open to them and inside that limit.",
  capNoGuests: "Guests can't use this agent: “Who can chat” does not include {{label}}.",
  testGuest: "Test as guest",
  testSignedIn: "Test as signed-in",
  testHint: "Opens the Playground with that audience, so you see exactly what they get.",
  listTitle: "Sources",
  listHint: "Every source in the workspace. Access belongs to the source, so a change here applies everywhere it is used.",
  manage: "Open Knowledge Base",
  caption: "Workspace knowledge sources",
  cols: { use: "Use in this agent", source: "Source", status: "Status", chunks: "Chunks", access: "Who can read it" },
  useIn: "Use {{name}} in this agent",
  usedOn: "{{name}} is now used by this agent",
  usedOff: "{{name}} is no longer used by this agent",
  accessFor: "Who can read {{name}}",
  access: {
    everyone: "Everyone incl. guests",
    signed_in: "Signed-in users",
    staff: "Staff only",
    custom: "Custom…",
    customNamed: "Custom: {{labels}}",
  },
  editCustom: "Edit access for {{name}}",
  editCustomShort: "Edit",
  accessSaved: "Access updated for {{name}}",
  appliesAll_one: "Applies to the {{count}} agent using this source",
  appliesAll_other: "Applies to all {{count}} agents using this source",
  appliesNone: "No agent uses this source yet",
  needsEdit: "Changing who can read a source needs the Knowledge edit permission. Ask a workspace admin.",
  needsLink: "Choosing which sources this agent uses needs permission to edit the agent.",
  piiConfirm: {
    title: "Make “{{name}}” visible to everyone?",
    body: "This source appears to contain {{kinds}}. Everyone, including people who haven't signed in, would be able to read answers built from it.",
    confirm: "Make visible to everyone",
    cancel: "Keep it private",
  },
  summaryLive: "{{guests}} sources visible to guests, {{members}} to signed-in users.",
  empty: {
    title: "No knowledge sources yet",
    body: "Add documents, a website or Q&As in the Knowledge Base, then choose them here. Your agent answers only from what it uses.",
    cta: "Add knowledge",
  },
  error: { title: "Knowledge couldn't load", body: "Check your connection and try again. Nothing was changed." },
  forbidden: { title: "You can't view knowledge sources", body: "Your role doesn't include viewing the Knowledge Base. Ask a workspace admin if you need it." },
} as const;
